import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import { getApi } from "@beeldit/core/helpers/api";
import { isUsableConfigData } from "./isUsableConfigData";

function useGetConfiguration() {
  const errorHandler = useErrorHandler();

  return (
    configurationKey: string,
    onSuccess: any = (data: any) => {
      return data;
    }
  ) => {
    getConfiguration(configurationKey)
      .then((response: any) => {
        let data = response.data;
        onSuccess(data);
      })
      .catch((error: any) => {
        errorHandler(error);
      });
  };
}

async function getConfiguration(configurationKey: string) {
  // Comprueba si existe en localstorage, no está caducado y contiene datos válidos.
  const cached = localStorage.getItem(configurationKey);
  if (cached) {
    try {
      const item = JSON.parse(cached);
      if (
        item.expiration > new Date().getTime() &&
        isUsableConfigData(item?.value?.data)
      ) {
        return item.value;
      }
    } catch (e) {
      // Cache corrupta: la ignoramos y vamos a la API.
    }
  }
  return await getApi().get(`/configurations/${configurationKey}`);
}


export default useGetConfiguration;
